<!-- Top badges -->
<div class="d-flex align-items-center mb-3">
    <span class="badge badge-light-success fs-2 fw-bold px-2 py-1 rounded-pill me-2">
      Skill Development
    </span>
    <span class="badge badge-light-success fs-2 fw-bold px-2 py-1 rounded-pill">
      Fitness Enhancement
    </span>
  </div>
  
  <!-- Info lines -->
  <div class="mb-2 d-flex align-items-start">
    <i class="bi bi-clock-fill text-success me-2 fs-4 mr-1"></i>
    <div>
      <div class="fw-bold text-dark">Service Delivery</div>
      <div class="text-muted">Offline</div>
    </div>
  </div>
  
  <hr class="separator">

  <div class="mb-2 d-flex align-items-start">
    <i class="bi bi-geo-alt-fill text-success me-2 fs-4 mr-1"></i>
    <div>
      <div class="fw-bold text-dark">Service Location</div>
      <div class="text-muted">Egypt</div>
    </div>
  </div>
  
  <hr class="separator">

  <div class="mb-2 d-flex align-items-start">
    <i class="bi bi-person-fill text-success me-2 fs-4 mr-1"></i>
    <div>
      <div class="fw-bold text-dark">Preferred Age</div>
      <div class="text-muted">25 - 50</div>
    </div>
  </div>
  